module.exports = __webpack_public_path__ + "themes/mf/img/prize-3@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-3@2x.png
// module id = 91
// module chunks = 3